export const SPECIAL_PROMO_VALIDATION = {
    title: {
        required: 'Text title wajib diisi',
    },
    voucher_ids: {
        required: 'Voucher list wajib diisi',
    },
}
